module.exports = __webpack_public_path__ + "img/MY_ADDRESS.8d4274bf.png";